// @ts-nocheck
// Ported byte-identically from obd3-gui v1
// (src/features/dashboard/components/KpiStrip.tsx). Persistent KPI strip
// above the tabs, backed by the `kpi` layout scope so KPI tiles persist
// independently from per-tab widget layouts.
import { type WidgetId } from '../config';
import { useDashboardLayout } from '../use-dashboard-layout';
import { WidgetGrid } from './WidgetGrid';

interface Props {
  role: string;
  editing: boolean;
}

export function KpiStrip({ role, editing }: Props) {
  const { layout, reorder, setSize, remove } = useDashboardLayout('kpi');
  if (layout.length === 0) return null;
  return (
    <WidgetGrid
      layout={layout}
      editing={editing}
      onReorder={reorder}
      onResize={(id: WidgetId, size) => setSize(id, size)}
      onRemove={remove}
      role={role}
      fixedCols={5}
    />
  );
}
